import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ConfirmService } from '../../../core/services/confirm/confirm.service';
@Component({ selector: 'app-confirm', standalone: true, templateUrl: './confirm.component.html', styleUrl: './confirm.component.css', changeDetection: ChangeDetectionStrategy.OnPush })
export class ConfirmComponent {
  private readonly confirm = inject(ConfirmService);
  protected readonly request = this.confirm.request;
  protected resolve(value: boolean): void { this.confirm.resolve(value); }
}
